export const AVATAR_HUGE_SIZE_ERROR = 'File size should be less than 100 MB';
